// This file is auto-generated by @hey-api/openapi-ts

import type { RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { DeleteUsingPostData, DeleteUsingPostErrors, DeleteUsingPostResponses, HistoryUsingGetData, HistoryUsingGetErrors, HistoryUsingGetResponses, StatusUsingGetData, StatusUsingGetErrors, StatusUsingGetResponses, SubmitByLinkUsingPostData, SubmitByLinkUsingPostErrors, SubmitByLinkUsingPostResponses, SubmitByUploadUsingPostData, SubmitByUploadUsingPostErrors, SubmitByUploadUsingPostResponses } from '../types.gen';

export class DesktopCaptionControllerService {
    /**
     * delete
     */
    public static deleteUsingPost<ThrowOnError extends boolean = false>(options: Options<DeleteUsingPostData, ThrowOnError>): RequestResult<DeleteUsingPostResponses, DeleteUsingPostErrors, ThrowOnError> {
        return (options.client ?? client).post<DeleteUsingPostResponses, DeleteUsingPostErrors, ThrowOnError>({ url: '/v1/desktop/caption/delete', ...options });
    }
    
    /**
     * history
     */
    public static historyUsingGet<ThrowOnError extends boolean = false>(options?: Options<HistoryUsingGetData, ThrowOnError>): RequestResult<HistoryUsingGetResponses, HistoryUsingGetErrors, ThrowOnError> {
        return (options?.client ?? client).get<HistoryUsingGetResponses, HistoryUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/caption/history', ...options });
    }
    
    /**
     * submitByLink
     */
    public static submitByLinkUsingPost<ThrowOnError extends boolean = false>(options?: Options<SubmitByLinkUsingPostData, ThrowOnError>): RequestResult<SubmitByLinkUsingPostResponses, SubmitByLinkUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<SubmitByLinkUsingPostResponses, SubmitByLinkUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/caption/link',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * status
     */
    public static statusUsingGet<ThrowOnError extends boolean = false>(options: Options<StatusUsingGetData, ThrowOnError>): RequestResult<StatusUsingGetResponses, StatusUsingGetErrors, ThrowOnError> {
        return (options.client ?? client).get<StatusUsingGetResponses, StatusUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/caption/status', ...options });
    }
    
    /**
     * submitByUpload
     */
    public static submitByUploadUsingPost<ThrowOnError extends boolean = false>(options?: Options<SubmitByUploadUsingPostData, ThrowOnError>): RequestResult<SubmitByUploadUsingPostResponses, SubmitByUploadUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<SubmitByUploadUsingPostResponses, SubmitByUploadUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/caption/upload',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
}
